<tt-page>
    <tt-postplace class="col-xs-12 col-md-3 sp-0" [params]="params" (submit)="onSubmit($event)"></tt-postplace>
</tt-page>
